import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const JobDetailsDescriptionWrapper = styled(Box)<{ isDevice?: boolean }>`
  && {
    width: 100%;

    --accent1: ${props => props.theme.colors.accent1};
    --error: ${props => props.theme.colors.error};
  }

  && p,
  && li {
    margin: 0;
    font-size: 1.125rem;
    color: ${props => props.theme.colors.accent1};
  }

  && .ql-size-large,
  && h2,
  && h3,
  && h4,
  && h5,
  && h6 {
    font-size: 1.4375rem;
    letter-spacing: 0.25px;
    margin-top: 0;
  }

  && .ql-size-small {
    font-size: 0.75rem;
    letter-spacing: 0.25px;
  }
`
